import React, { useEffect } from 'react';

import { Input } from 'twyne-new.ui'

import PropertyItem from './Property';
import { TYPE_LABEL } from './types';

export default class LabelPropertyItem extends PropertyItem {
  accept = []
  title = "label-property"
  model = TYPE_LABEL

  PropertyValue = ({ value, setValue }) => {

    useEffect(() => {
      setValue('{label}')
    }, [])

    return <div className='pr-4'>
      <Input value={value} disabled />
    </div>
  }
}